<script>
import formsMixin from "@/mixin/forms";
import money from "@/components/mcomponents/cleave/Money";
import date from "@/components/mcomponents/cleave/Date";
import mtime from "@/components/mcomponents/cleave/Time";

import { MFormMixin } from "@/components/m-form";
import { parseInt } from "lodash";

export default {
  components: { money, date, mtime },
  mixins: [
    MFormMixin,
    formsMixin,
  ],
  props: {
    module: {
      required: true,
      default: 'wares'
    },
  },
  data() {
    return {
      baseUrl: "companies/config",
      appendSlash: true,
      rowKey: "codename",
      isEditing: false,
      rows: [],
      boolean_choices: [
        {title: 'بلی', value: 'True'},
        {title: 'خیر', value: 'False'},
      ],

    };
  },
  computed: {
    title() {
      let title = 'تنظیمات '
      if (this.module == 'wares') {
        return title + ' بازرگانی'
      }
      return this.setDocumentTitle(title);
    },
  },
  watch: {
    rows: {
      handler(newRows, oldRows) {
      },
      deep: true,
    },

  },
  mounted() {
    this.getConfigs()
  },
  methods: {
    getConfigs() {
      this.request({
        url: this.endpoint("companies/config"),
        method: "get",
        params: {
          module: this.module
        },
        success: (data) => {
          this.isEditing = false
          this.rows = data
        },
      });
    },
    updateConfigs() {
      this.request({
        url: this.endpoint("companies/config"),
        method: "put",
        data: this.getSerializedRows(),
        success: () => {
          this.notify('تنظیمات ثبت شد', 'success')
          this.getConfigs()
        },
      });
    },
    getSerializedRows() {
      return {
        items: this.rows.filter((o) => o.id)
      }
    },
  },
};
</script>
